import {SalesChannel} from '../consts/sales-channel.enum';
import {BusinessParameter} from '../../shared/models/request-offer/request-header.model';
import {SessionStatusCode} from '../enums/session-status-code.enum';

export interface SessionStatus {
    code?: number;
    statusCode?: SessionStatusCode;
    message?: string;
    paymentUrl?: string;
    paymentMethod?: string;
    policyNumberFromInsuranceCompany?: string;
}

export interface SalesChannelNotificationStatusesConfig {
    salesChannel: SalesChannel;
    statuses: NotificationStatusConfig[];
    default?: boolean;
}

export interface NotificationStatusConfig {
    codes: SessionStatusCode[];
    status: number;
    type: NotificationDisplayType;
    title?: string;
    descriptions?: string[]; // displayed below title
    imageSrc?: string;
    imageSrcMobile?: string;
    loading?: boolean;
    sessionMessage?: string;
    bannerVisible: boolean;
    productsVisible: boolean;
    footerVisible: boolean;
    footerFeaturedProductsAllowed: boolean;
    buttonLabel?: string;
    headerConfig: NotificationAppHeaderConfig;
    cssClassSuffix?: string;
}

export interface NotificationAppHeaderConfig {
    submitGoogleReviewButtonVisible: boolean;
    titleVisible: boolean;
    navigationVisible: boolean;
}

export enum NotificationDisplayType {
    STATIC = 'STATIC', // content based on notification status config
    SESSION_MESSAGE = 'SESSION_MESSAGE', // content based on message from session
}

// FIXME
export interface WebsocketNotification {
    header: {
        messageType: string;
        requestId: string;
        processContext: {
            processId: string;
            universalParameters: BusinessParameter[];
        };
        universalParameters: BusinessParameter[];
    };
    body: {
        status: number;
        message: string;
    }
}

